export default __webpack_public_path__ + "static/open-sans-v15-latin-700-ec32d6be7329ece0789ccf9d0d519c4d.ttf";